// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6918) return "static/chunks/6918-ba6da733e488a10b.js";
	if (chunkId === 1837) return "static/chunks/1837-bb9f07173c657e9f.js";
	if (chunkId === 2552) return "static/chunks/2552-99f97c18ca3c49a3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1780":"3cd29c2bf9b0f95f","2324":"34ce4ccdb74dc9bb","9125":"759b16ac2cc0ff09","9272":"486d0d5c3f842e2f","9724":"b1994eb1d9898fb3"}[chunkId] + ".js";
};